export default "__VITE_ASSET__JePfNWWS__"